import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppCommonModule } from '@app/components/app.common.module';
import { ModalService } from '@app/components/modal/modal.service';
import { BrandService } from '../../brand.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-brand-template',
  standalone: true,
  templateUrl: './brand-template.component.html',
  styleUrls: ['./brand-template.component.css'],
  imports: [FormsModule, ReactiveFormsModule, AppCommonModule, CommonModule],
})

export class BrandTemplateComponent implements OnChanges {
  @Input() isEdit: boolean = false;
  @Input() brandData: any = null;

  @Output() save = new EventEmitter<any>();
  @Output() update = new EventEmitter<any>();

  form: FormGroup;
  isTermError: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private router: Router,
    private service: BrandService,
    private cd: ChangeDetectorRef
  ) {
      this.createForm();
  }

  ngOnChanges() {
    if (this.isEdit && this.brandData) {
      this.updateForm();
    }
    console.log(this.isEdit)
  }

  createForm(){
    this.form = this.fb.group({
      name: ['', Validators.required],
      brandCode: [''],
      enabled: [true]
    });
  }

  closeModal() {
    this.modalService.closeModal();
  }

  create() {
    this.isLoading = true;
    if (this.form.invalid) {
      console.error('Formulario inválido:', this.form.errors);
      return;
    }
    const brandInfo = this.form.value;
    if (this.isEdit) {
      this.service.updateBrand(this.brandData.id, brandInfo).subscribe(
        response => {
          this.closeModal();
          this.update.emit(brandInfo);
          this.isLoading = false;
        },
        error => {
          console.error('Error al actualizar marca:', error);
          this.isLoading = false;
        }
      );
    } else {
      this.service.createBrand(brandInfo).subscribe(
        response => {
          this.closeModal();
          this.save.emit(brandInfo);
          this.isLoading = false;
        },
        error => {
          console.error('Error al crear marca:', error);
          this.isLoading = false;
        }
      );
    }
  }

  updateForm() {
    if (this.brandData) {
      this.form.patchValue({
        name: this.brandData.name,
        brandCode: this.brandData.brandCode,
        enabled: this.brandData.enabled,
      });
    }
  }
}
